import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../features/auth/authSlice";
import { getFullApiUrl } from "../config";
import { TopNav, Button, IconButton, Icon } from "../designSystem";

const LINKS = [
  { id: "home", label: "节目", path: "/" },
  { id: "videos", label: "视频", path: "/videos" },
  { id: "membership", label: "会员", path: "/membership-intro" },
  { id: "apps", label: "客户端", path: "/apps" },
  { id: "help", label: "帮助", path: "/help" },
];

function activeIdFromPath(pathname) {
  if (pathname === "/") return "home";
  if (pathname.startsWith("/video")) return "videos";
  if (pathname.startsWith("/membership") || pathname.startsWith("/subscription"))
    return "membership";
  if (pathname.startsWith("/apps")) return "apps";
  if (pathname.startsWith("/help")) return "help";
  return "";
}

export default function Appbar() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { token } = useSelector((state) => state.auth);
  const [menuOpen, setMenuOpen] = useState(false);

  const activeId = activeIdFromPath(location.pathname);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const go = (path) => {
    setMenuOpen(false);
    navigate(path);
  };

  const handleNavigate = (id) => {
    const link = LINKS.find((l) => l.id === id);
    if (link) go(link.path);
  };

  const handleLogout = async () => {
    setMenuOpen(false);
    try {
      await axios.post(
        getFullApiUrl("/api/v1/auth/logout"),
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
    } catch (error) {
      console.error("Logout failed:", error);
    }
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("podcast_session");
    dispatch(logout());
    window.location.href = "/";
  };

  return (
    <>
      <TopNav
        logo={`${process.env.PUBLIC_URL}/logo192.png`}
        links={LINKS.map(({ id, label }) => ({ id, label }))}
        activeId={activeId}
        onNavigate={handleNavigate}
        onLogoClick={() => go("/")}
        right={
          <>
            <span className="lt-nav-actions">
              {token !== null ? (
                <>
                  <Button size="sm" variant="ghost" onClick={() => go("/subscription/manage")}>
                    订阅
                  </Button>
                  <Button size="sm" variant="secondary" onClick={handleLogout}>
                    登出
                  </Button>
                </>
              ) : (
                <>
                  <Button size="sm" variant="ghost" onClick={() => go("/login")}>
                    登录
                  </Button>
                  <Button size="sm" onClick={() => go("/membership-intro")}>
                    成为会员
                  </Button>
                </>
              )}
            </span>
            <IconButton
              className="lt-nav-menubtn"
              icon={menuOpen ? "close" : "menu"}
              label="菜单"
              onClick={() => setMenuOpen((v) => !v)}
            />
          </>
        }
      />
      {menuOpen ? (
        <nav className="lt-mobilemenu">
          {LINKS.map((l) => (
            <button
              key={l.id}
              className={`lt-mobilemenu__item ${l.id === activeId ? "is-active" : ""}`}
              onClick={() => go(l.path)}
            >
              {l.label}
            </button>
          ))}
          {token !== null ? (
            <>
              <button
                className="lt-mobilemenu__item"
                onClick={() => go("/subscription/manage")}
              >
                <Icon name="credit_card" size={20} />
                订阅管理
              </button>
              <button className="lt-mobilemenu__item" onClick={() => go("/zsxq")}>
                <Icon name="link" size={20} />
                知识星球绑定
              </button>
              <button className="lt-mobilemenu__item" onClick={handleLogout}>
                <Icon name="logout" size={20} />
                登出
              </button>
            </>
          ) : (
            <button className="lt-mobilemenu__item" onClick={() => go("/login")}>
              <Icon name="login" size={20} />
              登录
            </button>
          )}
        </nav>
      ) : null}
    </>
  );
}
